module.exports = __webpack_public_path__ + "static/media/partner-french-care.96e6ff32.svg";